import React from "react";
import {
  Container,
  Row,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";

const columns = [
  {
    dataField: "id",
    text: "Id",
    formatter: (cell, row, rowIndex) => rowIndex + 1,
    headerStyle: { width: "5%" },
  },
  {
    dataField: "code",
    text: "Licence",
    style: { fontWeight: 600 },
  },
  {
    dataField: "status",
    text: "Status",
    headerStyle: { width: "15%" },
    formatter: (cell, row) => {
      return <Badge color="success">{cell}</Badge>;
    },
  },
];

export default function LicenseUserModal({ open, data, close, id_license }) {
  return (
    <Modal isOpen={open} centered scrollable={true}>
      <ModalHeader>
        <h3>User License</h3>
      </ModalHeader>
      <ModalBody style={{ padding: 0 }}>
        {data && data.length > 0 ? (
          <>
            <BootstrapTable
              keyField="id"
              data={data.map((code, index) => ({
                id: index + 1,
                code,
                status: "Active",
              }))}
              columns={columns}
            />
            <p  style={{padding: '12px', fontStyle: 'italic'}}>{[2128, 2129, 2130, 2131].includes(id_license) && "*The license that has been purchased is a perpetual license. Any future addition of user licenses will not incur any additional cost."}</p>
          </>
        ) : (
          <div style={{padding: '12px'}}>
            <p>Please use Main Key.</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={close}>Close</Button>
      </ModalFooter>
    </Modal>
  );
}
